export default __webpack_public_path__ + "static/media/legendary_snowman_gif.5c953aa4.gif";